import AsyncStorage from 'localforage'; // Use localforage for cross-browser storage

export const validateMobileFormat = (value: string) => {
  const mobileRegex = /^\d\d{9}$/;
  return mobileRegex.test(value);
};

export const dollarsInPoints = (value: any) => {
  return value / 100;
};

export const formatDate = (value: any) => {
  const date = new Date(value);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

export const formatPoints = (amount: any) => {
  return amount.toLocaleString('en-US', { maximumFractionDigits: 0 });
};

export const storeValue = async (key: string, value: string) => {
  try {
    await AsyncStorage.setItem(key, value);
  } catch (error) {
    // Error saving data
  }
};

export const getStoreValue = async (key: string) => {
  try {
    const response: any = await AsyncStorage.getItem(key);
    return response;
  } catch (error) {
    // Error getting data
    return null;
  }
};

export const deleteStoreValue = async (key: string) => {
  try {
    await AsyncStorage.removeItem(key);
  } catch (error) {
    // Error removing data
  }
};

export const errorHandling = (error: any) => {
  const errorCode = error?.title || error.metadata?.errors[0]?.extensions?.internal?.response?.body[0]?.detail;
  let errorMessageObj = {
    title: '',
    context: '',
  };

  switch (errorCode) {
    case 'FAIL_VALIDATE_OTP':
      errorMessageObj.title = 'Incorrect OTP!';
      errorMessageObj.context = 'You have provided an incorrect OTP. Please make sure to input the correct OTP sent to your mobile device.';
      break;
    case 'FAIL_VERIFY_USER':
      errorMessageObj.title = 'Incorrect OTP!';
      errorMessageObj.context = 'You have provided an incorrect OTP. Please make sure to input the correct OTP sent to your mobile device.';
      break;
    case 'FAIL_USER_NOT_FOUND':
      errorMessageObj.title = 'Incorrect PIN!';
      errorMessageObj.context = 'You have provided an incorrect PIN. Kindly input the correct PIN of your SukiAdvantage account.';
      break;
    case 'FAIL_MATCH_PIN':
      errorMessageObj.title = 'PIN does not match!';
      errorMessageObj.context = 'Please make sure to input the same PIN to continue.';
      break;
    case 'FAIL_SET_NEW_PIN':
      errorMessageObj.title = 'Current PIN Used!';
      errorMessageObj.context = 'Please provide a new PIN to ensure the security of your account.';
      break;
    default:
      errorMessageObj.title = 'Ooops!';
      errorMessageObj.context = 'Something went wrong. Please try again later.';
      break;
  }

  return errorMessageObj;
};

export const getBatchError = (batchError: any) => {
  const errorCode = batchError?.errors?.[0].code
  let errTitle = "", errMsg = "";
  switch(errorCode){
      case "BATCH_RECORD_ACCOUNT":
          errTitle = "Mobile number does not exist"
          errMsg = "One or more of the mobile numbers provided do not exist in our system. Please double-check and try again.";
          break
      case "INSUFFICIENT_PARTNER_POINTS":
      case "INSUFFICIENT_POINTS":
          errTitle = "Insufficient points balance";
          errMsg = "You do not have enough points to complete this batch transaction.";
          break
      case "FILE_INVALID_TYPE":
          errTitle = "Invalid file type";
          errMsg = "Please upload a file with the correct format (CSV).";
          break
      case "BATCH_RECORD_DUPLICATE":
          errTitle = "Customer duplicates";
          errMsg = "A customer with the same details already exists in the same CSV file.";
          break
      case "FILE_DUPLICATE":
          errTitle = "File Duplicate";
          errMsg = "The file you are uploading already exists. Please upload a different file."
          break
      case "INVALID_FORMAT":
          errTitle = "Invalid CSV format";
          errMsg = "Please ensure that the CSV file follows the required format and structure.";
          break
      case "MAX_POINTS":
          errTitle = "Points limit reached";
          errMsg = "One or more rows exceeded the 10,000 points limit per customer for this batch transaction."
          break
      default: 
          errTitle = 'Bad Request';
          errMsg = 'Something went wrong. Please try again later.';
          break
  }
  return [errTitle, errMsg]
}

export const extractApiError = (error: any) => {
  return (
    error?.response ?
    error?.response?.data?.metadata?.errors?.[0]?.extensions?.internal?.response?.body[0] :
    'Something went wrong.'
  );
};
